import React from 'react';
import Badge from 'react-bootstrap/Badge';

const CustBadge = props => {
    return <Badge {...props}>{props.text}</Badge>;
};

export default CustBadge;
